import AppButtonDrawerIcon from "./Icon/app-button-icon.png";
import AppExtendedLogo from "./Image/webinify-logo.png";
import EmptyAvatar from "./Image/empty-avatar.jpeg";

export default class AppAssets {

    static AppButtonDrawerIcon = AppButtonDrawerIcon;
    static AppExtendedLogo = AppExtendedLogo;
    static EmptyAvatar = EmptyAvatar;
}